export default __webpack_public_path__ + "static/common-footer-image-mobile-adba246ff46b7937b6bd79f0e5bc73ec.png";